import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';
import { ThumbList, TitleBlocContainer, DescriptionContainer } from 'modules/shared-cms-advanced/components';
import { Showroom } from 'modules/shared-cms-advanced/enhanced-blocs';
import { ListContainer } from 'modules/shared-ui/components';

import { CreatorsProps } from './creators-type';

import enhancer from './creators-enhancer';

import styles from './creators-page.module.css';

const InnerCreatorsPage: React.FC<CreatorsProps> = React.memo(({ creators, content }: CreatorsProps) => {
    const { ...rest } = content.data;
    const wrappedShowroomId = getDefault(getNestedReferenceId(content.data.showroom), '');

    return (
        <React.Fragment>
            <div className={`${styles.root} full-height full-width`}>
                <div className={styles.titleBlocSection}>
                    <TitleBlocContainer {...rest} />
                </div>
                <div className={styles.descriptionSection}>
                    <Container>
                        <div className={styles.descriptionText}>
                            <DescriptionContainer {...rest} />
                        </div>
                    </Container>
                </div>

                <ListContainer
                    title="CRÉATEUR"
                    list={creators}
                    noResultsTxt="Aucun créateur n'est disponible dans cette sélection pour l'instant. Nous vous
                            invitons à vous rapprocher de l'équipe Printemps Listes de votre magasin qui saura vous
                            accompagner dans votre recherche."
                >
                    <ThumbList thumbs={creators} useBrandId />
                </ListContainer>

                {wrappedShowroomId && <Showroom id={wrappedShowroomId} />}
            </div>
        </React.Fragment>
    );
});

export const CreatorsPage = enhancer(InnerCreatorsPage);
